import React from 'react';

export const MagicIcon = () => (
    <img className="w-5 h-5" src="https://api.builder.io/api/v1/image/assets/TEMP/4743f262cd89f26fbe6f02efbeb8c0692efe10fc?width=40" alt="Fix with AI" />
);
